import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  galleryPageAdditionalMeta,
  galleryPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import MainImage from '../../assets/images/main/main-half.png';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GalleryPageMainContainer from '../../components/gallery/GalleryPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function GalleryPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Gallery'
        desc={`Browse the exclusive gallery of ${CompanyName}. Explore captivating images from my sessions, showcasing the art of domination and submission.`}
        keywords={KeywordsPages}
        additionalMeta={galleryPageAdditionalMeta}
        structuredData={galleryPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
  

          {/* Main page content */}
          <GalleryPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default GalleryPage;
